/*const PROXY_URL = 'https://tolltwsfunctions.azurewebsites.net/mmapi/';
const TWS_LOGIN = 'https://tolltwsfunctions.azurewebsites.net/api/twslogin';
const TWS_FORGOT_LOGIN = 'https://tolltwsfunctions.azurewebsites.net/api/TWSForgotLogin';
const TWS_REGISTER = 'https://tolltwsfunctions.azurewebsites.net/api/twsregister?client=uniform';
const TWS_CIVIL_REGISTER = 'https://tolltwsfunctions.azurewebsites.net/api/twsregister?client=civilian';
const QAS = 'https://tolltwsfunctions.azurewebsites.net/api/QAS';
const AAD = 'umovemaestro.onmicrosoft.com';
*/
const PROXY_URL = 'https://tolltwsfunctions-p2sit.azurewebsites.net/mmapi/';
const TWS_LOGIN = 'https://tolltwsfunctions-p2sit.azurewebsites.net/api/twslogin';
const TWS_FORGOT_LOGIN = 'https://tolltwsfunctions-p2sit.azurewebsites.net/api/TWSForgotLogin';
const TWS_REGISTER = 'https://tolltwsfunctions-p2sit.azurewebsites.net/api/twsregister?client=uniform';
const TWS_CIVIL_REGISTER = 'https://tolltwsfunctions-p2sit.azurewebsites.net/api/twsregister?client=civilian';
const QAS = 'https://tolltwsfunctions-p2sit.azurewebsites.net/api/QAS';
const AAD = 'p2sitmovemaestro.onmicrosoft.com';
const USE_OLD_LOGIN = true;
const USE_REDIRECT = false;
const LOGIN_CLIENT_ID = '';
const LOGIN_SCOPE = '';

module.exports = {
    PROXY_URL
    ,TWS_LOGIN
    ,TWS_FORGOT_LOGIN
    ,TWS_REGISTER
    ,QAS
    ,AAD
    ,TWS_CIVIL_REGISTER
    ,USE_OLD_LOGIN
    ,USE_REDIRECT
    ,LOGIN_CLIENT_ID
    ,LOGIN_SCOPE
}